export var FinancialSectionType;
(function (FinancialSectionType) {
    FinancialSectionType["CONTRACT"] = "contract";
    FinancialSectionType["ESTIMATE"] = "estimate";
    FinancialSectionType["BUDGET"] = "budget";
    FinancialSectionType["COST"] = "cost";
    FinancialSectionType["ESTIMATE_COST_CODE"] = "estimate_cost_code";
    FinancialSectionType["BUDGET_COST_CODE"] = "budget_cost_code";
    FinancialSectionType["COST_COST_CODE"] = "cost_cost_code";
    FinancialSectionType["ADJUSTMENT"] = "adjustment";
})(FinancialSectionType || (FinancialSectionType = {}));
